<div style="margin: 10px;">

	<jira-export-config [Network]="Network" [JiraExport]="JiraExport" [Agent]="Agent" [ScheduledDiscovery]="Discovery"
						[EnableExportOrigin]="true"></jira-export-config>

</div>
